import { Fragment } from 'react'

import { Checkbox, CHECKBOX_SIZE } from '../../../../Checkbox'
import {
  FormikField,
  getFormikCheckboxFieldValueProps,
} from '../../../../Formik'

import * as styles from '../../TableExportModal.module.css'

function FieldCheckbox({ label, name }) {
  return (
    <div className={styles.item}>
      <FormikField
        Component={Checkbox}
        Field={Fragment}
        className={styles.checkbox}
        getValueProps={getFormikCheckboxFieldValueProps}
        label={label}
        name={name}
        size={CHECKBOX_SIZE.small}
      />
    </div>
  )
}

export default FieldCheckbox
